import { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { coreLayoutContainer, coreLayoutSection } from '@/constants/measured-scope'
import { hexToRGBA } from '@/lib/colors'
import { CategoryInfoSection } from '@/shared/api-generated-types'
import { useMemo } from 'react'
import * as styles from './style'

export interface Props extends Partial<CategoryInfoSection> {}

const CategoryInfoBlock = ({ content }: Props): JSX.Element => {
  const backgroundColor = useMemo(() => {
    if (!content?.backgroundColor) return
    return { backgroundColor: hexToRGBA(content?.backgroundColor, 0.15) }
  }, [content?.backgroundColor])
  const titleColor = useMemo(() => {
    if (!content?.backgroundColor) return
    return { color: content?.backgroundColor }
  }, [content?.backgroundColor])
  return (
    <header className={`${coreLayoutSection} mb-sm mb-lg-gte-sm mb-lg-gte-lg`} style={backgroundColor}>
      <Stack x className={`${coreLayoutContainer} pt-sm pt-lg-gte-lg`} alignItems="center" justifyContent="flex-start">
        {content?.iconUrl && <img src={content.iconUrl} className={`${styles.icon} drop-shadow`} loading="lazy" />}
        {content?.title && (
          <Text tag="h2" weight="lg" size="lg" responsiveSize={{ lg: 'xl' }}>
            <span style={titleColor}>{content.title}</span>
          </Text>
        )}
      </Stack>
    </header>
  )
}

export default CategoryInfoBlock
